module.exports = __webpack_public_path__ + "static/img/168.cc622dc.png";